module.exports = fox._r("fonts/museosanscyrl_1-webfont.ttf", __webpack_public_path__ + "fonts/1hwgpx8.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl_1-webfont.ttf
// module id = 582
// module chunks = 2